module.exports = __webpack_public_path__ + "img/eye.f2eec9d2.svg";